import { CssColours } from '@/static/colours'
import { Resolution } from '@/types'
import * as PIXI from 'pixi.js'

export const thresholdPixels = 6

let xAxisTransformerLine: PIXI.Graphics | null
let yAxisTransformerLine: PIXI.Graphics | null

let applySnapTimeout: NodeJS.Timeout | null = null

export function destroyTransformerAxisLines (): void {
  xAxisTransformerLine?.destroy()
  xAxisTransformerLine = null
  yAxisTransformerLine?.destroy()
  yAxisTransformerLine = null
}

/**
 * Returns the axisTransformer graphics objects to be rendered as required
 * @param sprite The sprite that is being transformed
 */
function getTransformerAxisLines (sprite: PIXI.Sprite, canvasResolution: Resolution): PIXI.Graphics[] {
  const transformerAxisLines: PIXI.Graphics[] = []
  const canvasCenterX = canvasResolution.width / 2
  const canvasCenterY = canvasResolution.height / 2
  const spriteCenterX = sprite.x
  const spriteCenterY = sprite.y
  destroyTransformerAxisLines()
  
  if (Math.abs(canvasCenterX - spriteCenterX) <= thresholdPixels) {
    yAxisTransformerLine = new PIXI.Graphics()
    yAxisTransformerLine.lineStyle(6, PIXI.utils.string2hex(CssColours.INTERACTIVE_BLUE))
      .moveTo(canvasCenterX, 0)
      .lineTo(canvasCenterX, canvasResolution.height)

    transformerAxisLines.push(yAxisTransformerLine)
  }

  if (Math.abs(canvasCenterY - spriteCenterY) <= thresholdPixels) {
    xAxisTransformerLine = new PIXI.Graphics()

    xAxisTransformerLine.lineStyle(6, PIXI.utils.string2hex(CssColours.INTERACTIVE_BLUE))
      .moveTo(0, canvasCenterY)
      .lineTo(canvasResolution.width, canvasCenterY)

    transformerAxisLines.push(xAxisTransformerLine)
  }
  return transformerAxisLines
}

export function applyAxisSnapToSprite (sprite: PIXI.Sprite, canvasResolution: Resolution): PIXI.Graphics[] {
  if (applySnapTimeout === null) {
    // We use a timeout here so that the axis snap does not happen constantly
    applySnapTimeout = setTimeout(() => {
      const canvasCenterX = canvasResolution.width / 2
      const canvasCenterY = canvasResolution.height / 2
      const spriteCenterX = sprite.x
      const spriteCenterY = sprite.y

      if (Math.abs(canvasCenterX - spriteCenterX) <= thresholdPixels) {
        sprite.x = canvasCenterX
      }

      if (Math.abs(canvasCenterY - spriteCenterY) <= thresholdPixels) {
        sprite.y = canvasCenterY
      }
      applySnapTimeout = null
    }, 300)
  }

  return getTransformerAxisLines(sprite, canvasResolution)
}